`<template>
  <div class="home hotel container">
    <CustomerService></CustomerService>
    <Carousel height="607.5px" theme="banner" :list="banner" />
    <div class="page-intro text-center" v-if="hotelDetail">
      <div class="page-title">
        <div class="tag" v-if="hotelDetail.houseResources.propertyType_translate">{{
          hotelDetail.houseResources.propertyType_translate }}</div>
        <h1>{{ hotelDetail.houseResources.name_translate }}</h1>
      </div>
      <div class="page-content">
        <p style="white-space: pre-line; text-align: center">
          {{ hotelDetail.hotelDescription.description_translate }}
        </p>
        <ul class="hotel-facility" v-if="houtelAmenityList.length > 0">
          <li v-for="item in houtelAmenityList" :key="item.attributeId">
            <img :src="`${publicPath}icon/${item.attributeId}.png`" />
            <div class="icon-svg">
              <svg width="33px" height="31px" viewBox="0 0 33 31" version="1.1" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink">
                <g id="页面-1" stroke="none" stroke-width="1" fill-rule="evenodd">
                  <g id="资源-8" transform="translate(0.827388, -0.000216)" fill-rule="nonzero">
                    <path
                      d="M28.0926117,9.74021633 C30.0039402,14.0250944 29.6281124,18.9845333 27.0929003,22.9324511 C24.5576881,26.880369 20.2042381,29.2855207 15.5126117,29.3302163 C7.98923456,29.1282965 1.99527106,22.9713026 1.99527106,15.4452163 C1.99527106,7.91913002 7.98923456,1.76213617 15.5126117,1.56021633 C18.8161292,1.54796141 22.012658,2.73067705 24.5126117,4.89021633 L25.6226117,3.79021633 C22.8290117,1.33383128 19.232533,-0.0144035553 15.5126117,0 C8.61154372,-0.0361440599 2.52550088,4.51437486 0.608539073,11.1439539 C-1.30842274,17.773533 1.40990123,24.8698598 7.26542581,28.5221048 C13.1209504,32.1743497 20.6896131,31.4942875 25.8002771,26.8567046 C30.910941,22.2191217 32.3206937,14.7518774 29.2526117,8.57021633 L28.0926117,9.74021633 Z"
                      id="路径"></path>
                    <polygon id="路径"
                      points="31.8526117 5.00021633 28.6026117 1.73021633 20.2726117 10.1102163 20.2826117 10.1202163 12.8326117 17.2102163 8.9526117 13.3002163 5.8026117 15.9102163 13.3926117 23.7302163 23.8926117 13.0102163">
                    </polygon>
                  </g>
                </g>
              </svg>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="main">
      <div class="search hotel-search">
        <el-form :model="form" ref="form" class="search-form">
          <div class="search-col2">
            <el-form-item prop="date" class="date-picker">
              <div class="icon-svg checkin">
                <svg width="31px" height="30px" viewBox="0 0 31 30" version="1.1" xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink">
                  <g id="页面-1" stroke="none" stroke-width="1" fill-rule="evenodd">
                    <g id="icon-check-in" transform="translate(0.990000, 0.000000)" fill-rule="nonzero">
                      <path
                        d="M27.64,3.13 L26.57,3.13 L26.57,1.59 C26.57,0.71 25.86,0 24.98,0 L23.78,0 C22.9,0 22.19,0.71 22.19,1.59 L22.19,3.13 L7.51,3.13 L7.51,1.59 C7.51,0.71 6.8,0 5.92,0 L4.72,0 C3.84,0 3.13,0.71 3.13,1.59 L3.13,3.13 L2.37,3.13 C1.06,3.13 0,4.19 0,5.5 L0,27.63 C0,28.94 1.06,30 2.37,30 L27.64,30 C28.95,30 30.01,28.94 30.01,27.63 L30.01,5.49 C30.01,4.18 28.95,3.12 27.64,3.12 L27.64,3.13 Z M20.48,19.81 C20.48,19.81 20.47,19.84 20.46,19.86 C20.46,19.88 20.45,19.9 20.44,19.92 C20.44,19.94 20.42,19.96 20.41,19.98 C20.41,20 20.39,20.01 20.38,20.03 C20.36,20.06 20.33,20.1 20.3,20.13 L15.44,24.99 C15.2,25.23 14.8,25.23 14.56,24.99 C14.32,24.75 14.32,24.35 14.56,24.11 L18.35,20.32 L10.15,20.32 C9.98,20.32 9.82,20.25 9.71,20.14 C9.6,20.03 9.53,19.87 9.53,19.7 C9.53,19.35 9.81,19.07 10.15,19.08 L18.36,19.08 L14.57,15.29 C14.33,15.05 14.33,14.65 14.57,14.41 C14.81,14.17 15.21,14.17 15.45,14.41 L20.31,19.27 C20.31,19.27 20.36,19.33 20.39,19.37 C20.4,19.39 20.41,19.4 20.42,19.42 C20.43,19.44 20.44,19.46 20.45,19.48 C20.45,19.5 20.46,19.52 20.47,19.54 C20.47,19.56 20.48,19.58 20.49,19.59 C20.51,19.67 20.51,19.75 20.49,19.83 L20.48,19.81 Z M28.76,9.38 L1.26,9.38 L1.26,5.5 C1.26,4.88 1.76,4.38 2.38,4.38 L3.14,4.38 L3.14,5.92 C3.14,6.8 3.85,7.51 4.73,7.51 L5.93,7.51 C6.81,7.51 7.52,6.8 7.52,5.92 L7.52,4.38 L22.21,4.38 L22.21,5.92 C22.21,6.8 22.92,7.51 23.8,7.51 L25,7.51 C25.88,7.51 26.59,6.8 26.59,5.92 L26.59,4.38 L27.66,4.38 C28.28,4.38 28.78,4.88 28.78,5.5 L28.78,9.38 L28.76,9.38 Z"
                        id="d"></path>
                    </g>
                  </g>
                </svg>
              </div>
              <div class="icon-svg checkout">
                <svg width="31px" height="30px" viewBox="0 0 31 30" version="1.1" xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink">
                  <g id="页面-1" stroke="none" stroke-width="1" fill-rule="evenodd">
                    <g id="icon-check-out" transform="translate(0.990000, 0.000000)" fill-rule="nonzero">
                      <path
                        d="M27.64,3.07 L26.57,3.07 L26.57,1.56 C26.57,0.7 25.86,0 24.98,0 L23.78,0 C22.9,0 22.19,0.7 22.19,1.56 L22.19,3.07 L7.51,3.07 L7.51,1.56 C7.51,0.7 6.8,0 5.92,0 L4.72,0 C3.84,0 3.13,0.7 3.13,1.56 L3.13,3.07 L2.37,3.07 C1.06,3.07 0,4.12 0,5.4 L0,27.19 C0,28.48 1.06,29.52 2.37,29.52 L27.64,29.52 C28.95,29.52 30.01,28.47 30.01,27.19 L30.01,5.41 C30.01,4.12 28.95,3.08 27.64,3.08 L27.64,3.07 Z M19.87,19.98 L11.66,19.98 L15.45,23.71 C15.69,23.95 15.69,24.34 15.45,24.58 C15.21,24.82 14.81,24.82 14.57,24.58 L9.71,19.8 C9.71,19.8 9.66,19.74 9.63,19.71 C9.62,19.69 9.61,19.68 9.6,19.66 C9.59,19.64 9.58,19.62 9.57,19.6 C9.57,19.58 9.56,19.56 9.55,19.54 C9.55,19.52 9.54,19.51 9.53,19.49 C9.51,19.41 9.51,19.33 9.53,19.25 C9.53,19.23 9.54,19.22 9.55,19.2 C9.55,19.18 9.56,19.16 9.57,19.14 C9.57,19.12 9.59,19.1 9.6,19.08 C9.6,19.06 9.62,19.05 9.63,19.03 C9.65,19 9.68,18.96 9.71,18.94 L14.57,14.16 C14.81,13.92 15.21,13.92 15.45,14.16 C15.69,14.4 15.69,14.79 15.45,15.03 L11.66,18.76 L19.87,18.76 C20.04,18.76 20.2,18.83 20.31,18.94 C20.42,19.05 20.49,19.21 20.49,19.37 C20.49,19.71 20.21,19.98 19.87,19.98 Z M28.76,9.22 L1.26,9.22 L1.26,5.4 C1.26,4.79 1.76,4.3 2.38,4.3 L3.14,4.3 L3.14,5.81 C3.14,6.67 3.85,7.37 4.73,7.37 L5.93,7.37 C6.81,7.37 7.52,6.67 7.52,5.81 L7.52,4.3 L22.21,4.3 L22.21,5.81 C22.21,6.67 22.92,7.37 23.8,7.37 L25,7.37 C25.88,7.37 26.59,6.67 26.59,5.81 L26.59,4.3 L27.66,4.3 C28.28,4.3 28.78,4.79 28.78,5.4 L28.78,9.22 L28.76,9.22 Z"
                        id="d"></path>
                    </g>
                  </g>
                </svg>
              </div>
              <el-date-picker v-model="date" value-format="yyyy-MM-dd" type="daterange"
                :start-placeholder="ts('Check-in')['Check-in']" :end-placeholder="ts('Check-out')['Check-out']"
                align="center" :clearable="false"> </el-date-picker>
            </el-form-item>
            <el-form-item class="guest-room" style="height: 40px">
              <el-popover placement="bottom" width="264" trigger="click" :disabled="!isHotel || roomType.length == 0">
                <div class="choice">
                  <div class="child-kid" v-for="(t, tIndex) in roomType" :key="t.value">
                    <label>{{ t.title }}</label>
                    <div class="actions">
                      <el-input-number v-model="t.number" :min="0" step-strictly></el-input-number>
                    </div>
                  </div>
                </div>
                <div class="info" slot="reference">
                  <div class="icon-svg">
                    <svg width="32px" height="29px" viewBox="0 0 32 29" version="1.1" xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink">
                      <g id="页面-1" stroke="none" stroke-width="1" fill-rule="evenodd">
                        <g id="资源-19" transform="translate(0.000000, -0.001268)">
                          <path
                            d="M4.47,14.8112684 L0.74,14.8112684 C0.33,14.8112684 0,14.4812684 0,14.0712684 C0,13.8412684 0.11,13.6312684 0.28,13.4912684 L15.06,0.191268379 C15.34,-0.0687316212 15.77,-0.0587316212 16.05,0.191268379 L31.02,13.5112684 C31.33,13.7812684 31.35,14.2512684 31.08,14.5612684 C30.93,14.7212684 30.73,14.8112684 30.52,14.8112684 L26.8,14.8112684 L26.8,27.5412684 C26.8,27.9512684 26.47,28.2812684 26.06,28.2812684 L19.78,28.2812684 C19.37,28.2812684 19.04,27.9512684 19.04,27.5412684 L19.04,19.3512684 L11.92,19.3512684 L11.92,27.5412684 C11.92,27.9512684 11.59,28.2812684 11.18,28.2812684 L5.21,28.2812684 C4.8,28.2812684 4.47,27.9512684 4.47,27.5412684 L4.47,14.8112684 Z"
                            id="路径"></path>
                        </g>
                      </g>
                    </svg>
                  </div>
                  <span style="color: #c0c4cc" v-if="showPlaceholder">{{ ts('Room Type')['Room Type'] }}</span>
                  <template v-else>
                    <span v-for="(n, nindex) in roomType" :key="n.value">
                      {{ n.number }}
                      <template v-if="nindex < roomType.length - 1">, </template>
                    </span>
                  </template>
                </div>
              </el-popover>
            </el-form-item>
            <div class="btn btn-theme hotel-submit" @click="submitForm('form')">{{ ts('Search')['Search'] }}</div>
          </div>
        </el-form>

        <div class="search-result" v-if="searchList">
          <div class="table" v-if="step == 1">
            <div class="table-header">
              <div class="title">{{ ts('Accommondation Fee')['Accommondation Fee'] }}</div>
            </div>
            <div class="table-content">
              <div class="sub-title">{{ ts('Date')['Date'] }} : {{ form.checkInDate }}~{{ form.checkOutDate }} ({{ days
                }} {{
                  ts('Nights')['Nights'] }})</div>
              <el-table :data="searchList" :border="false" style="width: 100%" v-if="searchList.length > 0">
                <el-table-column width="80">
                  <template slot-scope="scope">
                    <div class="col-del" v-if="!scope.row.isDisabled" @click="roomDelete(scope.$index)">{{
                      ts('Delete')['Delete'] }}</div>
                  </template>
                </el-table-column>
                <el-table-column :label="ts('Room Type')['Room Type']" prop="roomTypeName" align="center"
                  v-if="isHotel">
                  <template slot-scope="scope">
                    <div>{{ `${getListNumber(searchList, scope.row, scope.$index)}. ${scope.row.roomTypeName_translate
                      || scope.row.roomTypeName}` }}</div>
                  </template>
                </el-table-column>
                <el-table-column :label="ts('Property Name')['Property Name']" prop="roomTypeName" align="center"
                  v-else>
                  <template slot-scope="scope">
                    <div>{{ scope.row.roomTypeName_translate || scope.row.roomTypeName }}</div>
                  </template>
                </el-table-column>
                <el-table-column :label="ts('Vacancy')['Vacancy']" align="center">
                  <template slot-scope="scope">
                    <img src="../assets/images/table-right.svg" width="20" v-if="!scope.row.isDisabled" />
                    <img src="../assets/images/table-error.svg" width="20" v-else />
                  </template>
                </el-table-column>
                <el-table-column :label="ts('Guest')['Guest']" align="center">
                  <template slot-scope="scope">
                    <el-input-number :disabled="scope.row.isDisabled" v-model="scope.row.guestNum"
                      @change="handleGuestChange(scope.$index)" size="small" :min="1" :max="scope.row.capacity || 10"
                      step-strictly></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column :label="ts('Amount')['Amount']" align="center">
                  <template slot-scope="scope">
                    {{ !scope.row.isDisabled && scope.row.amount ? `${currency} ${scope.row.amount}` : '-' }}
                    <!-- {{ scope.row.amount ? `${currency} ${scope.row.amount}` : '-' }} -->
                  </template>
                </el-table-column>
              </el-table>
              <ul class="price-list">
                <li>
                  <span class="label">{{ ts('Sub-total')['Sub-total'] }} :</span>
                  <span class="value">{{ currency }} {{ roomSubTotal }}</span>
                </li>
                <template v-if="roomTaxes">
                  <li v-for="tax in roomTaxes" :key="tax.id">
                    <span class="label">{{ tax.name_translate }} :</span>
                    <span class="value">{{ currency }} {{ tax.taxPrice }}</span>
                  </li>
                </template>
                <li>
                  <span class="label">{{ ts('Accommondation Fee Total')['Accommondation Fee Total'] }} :</span>
                  <span class="value">{{ currency }} {{ roomTotal }}</span>
                </li>
              </ul>
            </div>
          </div>

          <!-- Other Fee -->
          <div class="table" v-else-if="step == 2">
            <div class="table-header">
              <div class="title">{{ ts('Other Fee')['Other Fee'] }}</div>
            </div>
            <div class="table-content">
              <el-table :data="otherFee" :border="false" style="width: 100%">
                <el-table-column :label="ts('Room Type')['Room Type']" prop="roomTypeName" align="center"
                  v-if="isHotel">
                  <template slot-scope="scope">
                    <div>{{ `${getListNumber(otherFee, scope.row, scope.$index)}. ${scope.row.roomTypeName_translate ||
                      scope.row.roomTypeName}` }}</div>
                  </template>
                </el-table-column>
                <el-table-column :label="ts('Property Name')['Property Name']" prop="roomTypeName" align="center"
                  v-else>
                  <template slot-scope="scope">
                    <div>{{ scope.row.roomTypeName_translate || scope.row.roomTypeName }}</div>
                  </template>
                </el-table-column>
                <el-table-column :label="ts('Fee Name')['Fee Name']" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.feeName ? scope.row.feeName : '-' }}
                  </template>
                </el-table-column>
                <el-table-column :label="ts('Charge Condition')['Charge Condition']" prop="feeUnit"
                  align="center"></el-table-column>
                <el-table-column :label="ts('Amount')['Amount']" align="center">
                  <template slot-scope="scope">{{ scope.row.feeValue ? `${currency} ${scope.row.feeValue}` : '-'
                    }}</template>
                </el-table-column>
              </el-table>
              <ul class="price-list">
                <li>
                  <span class="label">{{ ts('Sub-total')['Sub-total'] }} :</span>
                  <span class="value">{{ currency }} {{ feeSubTotal }}</span>
                </li>
                <template v-if="feeTaxes.length > 0">
                  <li v-for="t in feeTaxes" :key="t.id">
                    <span class="label">{{ t.name_translate }} :</span>
                    <span class="value">{{ currency }} {{ t.taxPrice }}</span>
                  </li>
                </template>
                <li>
                  <span class="label">{{ ts('Other Fee Total')['Other Fee Total'] }} :</span>
                  <span class="value">{{ currency }} {{ feeTotal }}</span>
                </li>
              </ul>
            </div>
          </div>

          <!-- Product / Activity /Service -->
          <ProductSelect ref="productSelect" @next="storeProductInfo" :hotelId="$route.params.id" :currency="currency"
            v-else-if="step == 3" />
          <!-- <ProductSelect ref="productSelect" @next="storeProductInfo" :hotelId="$route.params.id" :currency="currency" /> -->

          <!-- Billing Summary -->
          <div class="table billing-summary" v-else-if="step == 4">
            <div class="table-header">
              <div class="title">{{ ts('Billing Summary')['Billing Summary'] }}</div>
            </div>
            <div class="table-content">
              <ul class="price-list">
                <li>
                  <span class="label">{{ ts('Accommondation Fee Total')['Accommondation Fee Total'] }} :</span>
                  <span class="value">{{ currency }} {{ roomTotal }}</span>
                </li>
                <li>
                  <span class="label">{{ ts('Other Fee Total')['Other Fee Total'] }} :</span>
                  <span class="value">{{ currency }} {{ feeTotal }}</span>
                </li>
                <li v-if="productTotalPrice > 0">
                  <span class="label">{{ ts('Product / Activity / Service Total')['Product / Activity / Service Total']
                    }}
                    :</span>
                  <span class="value">{{ currency }} {{ productTotalPrice }}</span>
                </li>
              </ul>
              <div class="total-amount">{{ ts('TOTAL AMOUNT')['TOTAL AMOUNT'] }} : {{ currency }} {{ roomTotal +
                feeTotal +
                productTotalPrice }}</div>
            </div>
          </div>
          <div class="table register-form" style="margin-bottom: 24px;" v-if="step == 5">
            <div class="table-header">
              <div class="title">{{ ts('Member Registration')['Member Registration'] }}</div>
            </div>
            <el-form :model="registerForm" ref="registerForm" label-position="top" label-width="200px"
              class="user-form">
              <el-row :gutter="80">
                <el-col :span="12">
                  <el-form-item prop="firstname" :label="ts('First Name:')['First Name:']">
                    <el-tooltip class="box-item" :content="ts('Enter your first name here')['Enter your first name here']" placement="top">
                    <el-input v-model="registerForm.firstName"></el-input>
                    </el-tooltip>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item prop="lastname" :label="ts('Last Name:')['Last Name:']">
                    <el-tooltip class="box-item" :content="ts('Enter your last name here')['Enter your last name here']" placement="top">
                    <el-input v-model="registerForm.lastName"></el-input>
                    </el-tooltip>
                    </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="80">
                <el-col :span="12">
                  <div class="password" id="password1">
                    <el-form-item style="margin-bottom: 20px" prop="password" :label="ts('Password:')['Password:']"
                      :rules="[{ validator: validatePass, trigger: 'blur' }]">
                      <!-- <div class="item-icon">
                        <img src="../assets/images/icon-password2.svg" class="h-5 w-5 object-contain" alt="" />
                      </div>-->
                      <el-tooltip class="box-item" :content="ts('Create a password for your account')['Create a password for your account']" placement="top">
                      <el-input type="password" v-model="registerForm.password" autocomplete="off"></el-input>
                      </el-tooltip>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="password" id="password2">
                    <el-form-item prop="checkPass" :label="ts('Confirm Password:')['Confirm Password:']"
                      :rules="[{ validator: validatePass2, trigger: 'blur' }]">
                      <!-- <div class="item-icon">
                        <img src="../assets/images/icon-password1.svg" class="h-5 w-5 object-contain" alt="" />
                      </div> -->
                      <el-tooltip class="box-item" :content="ts('Confirm password')['Confirm password']" placement="top">
                      <el-input type="password" v-model="registerForm.checkPass" autocomplete="off"></el-input>
                      </el-tooltip>
                      </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="80">
                <el-col :span="12">
                  <!-- <el-form-item :label="ts('Nationality :')['Nationality :']" prop="nationality" class="nationality" :rules="[{ required: true, message: ts('不能为空')['不能为空'] }]">
                <vue-country-intl type="country" placeholder="" v-model="registerForm.nationality"></vue-country-intl>
              </el-form-item> -->
                  <el-form-item :label="ts('Contact Number :')['Contact Number :']" prop="contactNumber" class="phone"
                    :rules="[{ required: true, message: ts('不能为空')['不能为空'] }]">
                    <el-tooltip class="box-item" :content="ts('Enter your area code of phone number')['Enter your area code of phone number']" placement="top">
                    <vue-country-intl type="phone" placeholder="" :onlyValue="false" :showLabelImg="true"
                      v-model="registerForm.areaCode"></vue-country-intl>
                    </el-tooltip>
                    <el-tooltip class="box-item" :content="ts('Enter your contact phone number')['Enter your contact phone number']" placement="top">
                    <el-input v-model="registerForm.contactNumber"></el-input>
                    </el-tooltip>
                  </el-form-item>
                </el-col>

                <el-col :span="12">
                  <el-form-item id="username" :label="ts('Email:')['Email:']" prop="username"
                    :rules="[{ validator: checkUsername, trigger: 'blur' }]">
                    <!-- <div class="item-icon">
                      <img src="../assets/images/icon-user-black2.svg" class="h-5 w-5 object-contain" alt="" />
                    </div> -->
                    <el-tooltip class="box-item" :content="ts('Enter an email address for your account')['Enter an email address for your account']" placement="top">
                    <el-input v-model="registerForm.username" ></el-input>
                    </el-tooltip>
                  </el-form-item>
                </el-col>
              </el-row>

            </el-form>
          </div>
          <div class="result-footer pay" @click="createOrder" v-if="registerState.loggedin && step == 4">{{ ts('PAY
            NOW')['PAY
            NOW'] }}</div>
          <div class="result-footer" v-else-if="step == 5">
            <div class="back" @click="stepBack">{{ ts('BACK')['BACK'] }}</div>
            <div class="next" @click="submitRegisterForm('registerForm')" >{{ ts('NEXT')['NEXT'] }}</div>
            </div>
          <div class="result-footer" v-else>
            <div class="back" @click="stepBack">{{ ts('BACK')['BACK'] }}</div>
            <div class="next" @click="next" v-if="roomNum > 0">{{ ts('NEXT')['NEXT'] }}</div>
          </div>
        </div>
      </div>
      <div class="activity-list room-list">
        <RoomItem :list="list" />
      </div>
      <OtherSwiper :hotelId="$route.params.id" />
      <div class="hotel-map">
        <GmapMap :options="{
          zoomControl: true,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
          fullscreenControl: true,
          disableDefaultUi: false,
        }" :center="{ lat: parseFloat(0), lng: parseFloat(0) }" :zoom="16" ref="mapRef" map-type-id="terrain"
          style="width: 100%; height: 500px">
          <GmapMarker :position="marker" :clickable="true" :draggable="true" />
        </GmapMap>
      </div>
    </div>

    <!-- 支付方式 -->
    <el-dialog :visible.sync="payMethodVisible" width="1000px">
      <PayMethod orderType="GROUP_ORDER" :orderId="groupId" @confirm="createPayment" />
    </el-dialog>
  </div>
</template>

<script>
import { ACCESS_TOKEN, USER_NAME, USER_INFO } from '@/store/mutation-types'
import { getAction, postAction } from '@/api/manage'
import Carousel from '@/components/Carousel.vue'
import RoomItem from '@/components/RoomItem.vue'
import OtherSwiper from '@/components/OtherSwiper.vue'
import { LanguagePackage } from '@/mixins/LanguagePackage'
import PayMethod from '@/components/PayMethod.vue'
import ProductSelect from '@/components/ProductSelect.vue'
import CustomerService from '@/components/CustomerService.vue'
import tippy from 'tippy.js';

export default {
  name: 'Hotel',
  mixins: [LanguagePackage],
  components: {
    Carousel,
    RoomItem,
    OtherSwiper,
    PayMethod,
    ProductSelect,
    CustomerService,
  },
  data() {
    return {
      banner: [],
      pageSize: 99,
      pageNo: 1,
      date: '',
      form: {
        houseResourcesId: this.$route.params.id,
      },
      roomType: [],
      isHotel: false,
      list: [],
      roomList: [],
      fullscreenLoading: false,
      searchList: null,
      currency: '',

      roomPriceData: null,
      step: null,
      taxes: [],
      otherFee: [],

      hotelDetail: null,
      payMethodVisible: false,
      groupId: null,
      marker: { lat: 0, lng: 0 },
      productTotalPrice: 0,
      productOrderVoList: [],
      houtelAmenityList: [],
      publicPath: process.env.BASE_URL,
      registerForm: {
        firstName: "",
        lastName: "",
        contactNumber: "",
        password: "",
        checkPass: "",
        areaCode: ""
      },
      registerState: {
        loggedin: false,
        registered: false,
      }
    }
  },
  watch: {

  },
  computed: {
    days() {
      // 入住天数
      if (this.form.checkInDate && this.form.checkOutDate) {
        const days = this.$dayjs(this.form.checkOutDate).diff(this.$dayjs(this.form.checkInDate), 'day')
        return days
      }
      return 1
    },
    roomNum() {
      // 有效房间数量
      let arr = this.roomFilter()
      return arr.length
    },
    roomSubTotal() {
      // 房间总价
      let arr = this.roomFilter()
      let total = 0
      arr.forEach((item) => {
        total += item.amount
      })
      return total
    },
    roomTaxes() {
      // 房间税费列表
      // taxScope 为 1 的时候, 总房价 * taxValue/100
      // taxScope 为 3 的时候, 房间税费和费用税费都要计算
      let taxes = []
      if (this.roomPriceData) {
        taxes = this.roomPriceData.taxes
        taxes = taxes
          .map((item) => {
            if (item.taxScope == '1' || item.taxScope == '3') {
              item.taxPrice = parseInt((this.roomSubTotal * item.taxValue) / 100)
              return item
            }
            return null
          })
          .filter((x) => x !== null)
      }
      return taxes
    },
    roomTotal() {
      // 房间总费用
      let total = 0
      total = this.roomSubTotal + this.roomTaxes.reduce((a, b) => a + b.taxPrice, 0)
      return total
    },
    feeSubTotal() {
      // 费用总价
      let total = 0
      if (this.otherFee.length > 0) {
        this.otherFee.forEach((item) => {
          total += item.feeValue * 100
        })
        return total / 100
      }
      return total
    },
    feeSubPrice() {
      // 费用总价，用于计算税，排除 feeType 为 'DEPOSIT' 的费用
      let total = 0
      if (this.otherFee.length > 0) {
        this.otherFee.forEach((item) => {
          if (item.feeType != 'DEPOSIT') {
            total += item.feeValue * 100
          }
        })
        return total / 100
      }
      return total
    },
    feeTaxes() {
      // 费用税费列表
      // taxScope 为 2 的时候, 总费用 * taxValue / 100
      let taxes = []
      if (this.roomPriceData) {
        taxes = this.roomPriceData.taxes
        taxes = taxes
          .map((item) => {
            if (item.taxScope == '2' || item.taxScope == '3') {
              item.taxPrice = parseInt((this.feeSubPrice * item.taxValue) / 100)
              return item
            }
            return null
          })
          .filter((x) => x !== null)
      }
      return taxes
    },
    feeTotal() {
      // other fee 总费用
      let total = 0
      total = this.feeSubTotal + this.feeTaxes.reduce((a, b) => a + b.taxPrice, 0)
      return total
    },
    showPlaceholder() {
      // 默认展示 Room Type
      const index = this.roomType.findIndex((x) => x.number > 0)
      if (index > -1) {
        return false
      }
      return true
    },
  },
  created() {
    this.start();
  },
  mounted() { },
  methods: {
    start(){

      const { date } = this.$route.query
      if (date) {
        this.date = date
      }
      this.getData()
      this.getList()
      const userInfo = this.$ls.get(USER_INFO)
      if (!userInfo) {
        this.registerState.loggedin = false
      } else {
        this.registerState.loggedin = true
      }
    },
    checkUsername(rule, value, callback) {
      console.log(rule);
      console.log(value);
      let reg = /^([A-Za-z0-9_\-\.\u4e00-\u9fa5])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,8})$/
      // const usernameTip = tippy(document.getElementById('username'));
      if (!reg.test(value)) {
        callback(new Error(this.translate('Please enter the correct email address')))
        // usernameTip.setContent(this.translate('Please enter the correct email address'))
        // usernameTip.show();
      }

      if (!value) {
        callback(new Error(this.translate('请输入邮箱')))
        // usernameTip.setContent(this.translate('请输入邮箱'))
        // usernameTip.show();
      } else {
        callback()
      }
    },
    validatePass(rule, value, callback) {
      // const password1Tip = tippy(document.getElementById('password1'));
      // alert()
      if (value === '') {
        callback(new Error(this.translate('请输入密码')))
        // password1Tip.setContent(this.translate('请输入密码'))
        // password1Tip.show();
        // callback();
      } else {

        if (this.form.checkPass !== '') {
          this.$refs.form.validateField('checkPass')
        }
        callback()
      }
    },
    validatePass2(rule, value, callback) {
      // const password2Tip = tippy(document.getElementById('password2'));
      if (value === '') {
        callback(new Error(this.translate('请再次输入密码')))
        // password2Tip.setContent(this.translate('请再次输入密码'))
        // password2Tip.show();
      } else if (value !== this.registerForm.password) {
        callback(new Error(this.translate('两次输入密码不一致!')))
        // password2Tip.setContent(this.translate('两次输入密码不一致'))
        // password2Tip.show();
      } else {
        callback()
      }
    },
    submitRegisterForm(formName) {
      this.$refs[formName].validate((valid) => {
        this.btnLoading = true
        if (valid) {
          let params = { ...this.registerForm }
          delete params.checkPass
          const loading = this.$loading({
            lock: true,
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)',
          })
          // const usernameTip = tippy(document.getElementById('username'));
          getAction(`/pc/home/checkOnlyUser`, {
            username: params.username,
          }).then((res) => {
            console.log(res)
            if (res.success) {
              params.noMessage = true;
              postAction(`/pc/home/pmsRegisterFast`, params).then((res) => {
                console.log(res)
                if (!res.success) {
                  this.$message.error(this.translate(res.message));
                  loading.close()
                } else {
                  this.registerState.registered = true
                  let data = { username: params.username, password: params.password }
                  postAction(`/pc/home/memberLogin`, data).then((res) => {
                    console.log(res)
                    //this.loginBtn = false
                    if (res.code == '200') {
                      this.$ls.set(ACCESS_TOKEN, res.result.token, 7 * 24 * 60 * 60 * 1000)
                      this.$ls.set(USER_INFO, res.result.userInfo, 7 * 24 * 60 * 60 * 1000)
                      this.$store.commit('SET_INFO', res.result.userInfo)
                      this.$store.commit('updateUserIdInProductList', res.result.userInfo.id)
                      this.registerState.loggedin = true
                      postAction(`/pc/home/personalRegistration`, params).then((res) => {
                        console.log(res.message)
                        this.createOrder()
                      })

                      //this.$router.push('/user')
                    }else{
                      this.$message.error(this.translate(res.message));
                      loading.close()
                    }
                  })
                }
                this.btnLoading = false
              })
            } else {

              let data = { username: this.registerForm.username, password: this.registerForm.password }
              postAction(`/pc/home/memberLogin`, data).then((res) => {
                loading.close()
                console.log(res)
                //this.loginBtn = false
                if (res.code == '200') {
                  this.$ls.set(ACCESS_TOKEN, res.result.token, 7 * 24 * 60 * 60 * 1000)
                  this.$ls.set(USER_INFO, res.result.userInfo, 7 * 24 * 60 * 60 * 1000)
                  this.$store.commit('SET_INFO', res.result.userInfo)
                  this.$store.commit('updateUserIdInProductList', res.result.userInfo.id)
                  this.registerState.loggedin = true
                  this.createOrder()
                } else {
                  this.$message.error(this.translate('Username already exists, but password is different.'));
                  // usernameTip.setContent(this.translate('Username already exists, but password is different.'))
                  // usernameTip.show();
                }
              })

            }
          })

        } else {
          console.log('error submit!!')
          this.btnLoading = false
          return false
        }
      })
    },
    getData() {
      this.getHotelDetail()

      // 头部轮播图
      getAction(`/pc/home/qryCarousel`, {
        // userId: '1530918940765523970',
        typeId: this.$route.params.id,
        pickUp: false,
      }).then((res) => {
        this.banner = res.result
      })
    },
    // 房源详情
    getHotelDetail() {
      getAction(`/pc/home/qryHotelAmenity`, {
        hotelId: this.$route.params.id,
      }).then((res) => {
        this.hotelDetail = res.result
        this.houtelAmenityList = res.result.houtelAmenityList
        const { latitude, longitude, currency, propertyType } = res.result.houseResources
        this.currency = currency
        if (propertyType == 1) {
          // 酒店
          this.isHotel = true
          this.getRoomType()
        }
        this.$refs.mapRef.$mapPromise.then((map) => {
          map.panTo({ lat: parseFloat(latitude), lng: parseFloat(longitude) })
        })
        this.marker = {
          lat: parseFloat(latitude),
          lng: parseFloat(longitude),
        }
      })
    },
    getRoomType() {
      // 查询roomType
      getAction(`/pc/home/getDictItems/pms_house_room_type,name,id,house_resources_id='${this.$route.params.id}'`).then((res) => {
        console.log(res)
        if (res.result.length > 0) {
          let roomType = res.result
          roomType.forEach((item) => {
            item.number = 0
          })
          this.roomType = roomType
        }
      })
    },
    getList() {
      // const loading = this.$loading({
      //   lock: true,
      //   spinner: 'el-icon-loading',
      //   background: 'rgba(0, 0, 0, 0.7)',
      // })
      postAction(`/pc/home/qryRoomTypeByParam?pageSize=${this.pageSize}&pageNo=${this.pageNo}`, this.form).then((res) => {
        let list = res.result
        this.roomList = res.result
        if (!this.isHotel) {
          // 当这个房源是民宿的时候 只显示 is_room 为1的数据 0不显示（民宿有一条is_room 为 0的数据 这是它的房型，查询要用到）
          list = list
            .map((item) => {
              if (item.isRoom === 1) {
                return item
              }
              return null
            })
            .filter((x) => x !== null)
        }
        this.list = list
        // loading.close()
      })
    },
    // 搜索
    submitForm(formName) {
      this.roomPriceData = null
      this.getSearchData()
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    getSearchData() {
      if (this.date.length > 0) {
        this.form.checkInDate = this.date[0]
        this.form.checkOutDate = this.date[1]
      } else {
        this.form.checkInDate = ''
        this.form.checkOutDate = ''
        return this.$message({
          message: this.translate('Please select check date'),
          type: 'warning',
        })
      }

      if (this.isHotel) {
        // 查询酒店房间
        if (this.roomType.length > 0) {
          // 数量不能为0
          const index = this.roomType.findIndex((x) => x.number != 0)
          if (index == -1) {
            return this.$message({
              message: this.translate('Please select the number of room type'),
              type: 'warning',
            })
          }

          this.form.rooms = this.roomType.map((item) => {
            return {
              roomId: item.value,
              num: item.number,
            }
          })
        }
      } else {
        // 其它类型
        const room = this.roomList.find((x) => x.isRoom === 0)
        if (room) {
          this.form.rooms = [
            {
              roomId: room.roomTypeId,
              num: 1,
            },
          ]
        }
      }

      const loading = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })

      postAction(`/pc/home/qryRoomTypeByParam?pageSize=${this.pageSize}&pageNo=${this.pageNo}`, this.form)
        .then((res) => {
          let list = res.result
          // 获取价格模板
          let ids = list.map((item) => item.roomTypeId).toString()
          getAction(`/user/api/getRoomPrice`, {
            hotelId: this.$route.params.id,
            roomTypeIds: ids,
          })
            .then((res) => {
              this.roomPriceData = res.result

              if (list.length > 0) {
                // 设置默认入住人数
                list = list.map((item, index) => {
                  item.guestNum = 1
                  // 是否可用
                  if (item.roomNum <= item.inventory) {
                    item.isDisabled = false
                  } else {
                    item.isDisabled = true
                  }
                  item.amount = this.calculateAmount(item, index)
                  return item
                })
              }
              this.searchList = list
              this.step = 1
              loading.close()
            })
            .catch(() => {
              loading.close()
            })
        })
        .catch(() => {
          loading.close()
        })
    },
    // 计算房价
    // p1 就是你加一个人的时候 p2 就是你加到2个人的时候，天数*(roomPrice+p2)
    calculateAmount(room, index) {
      let price = this.days * room.roomPrice
      if (this.roomPriceData) {
        const id = room.roomTypeId
        const obj = this.roomPriceData.priceMap[id]
        // 人数
        const number = room.guestNum
        const pNum = `p${number}`
        if (obj && obj[pNum]) {
          // 附加费用存在
          price = this.days * (room.roomPrice + obj[pNum])
        }
      }
      return price
    },
    // 入住人数改变
    handleGuestChange(index) {
      this.searchList[index].amount = this.calculateAmount(this.searchList[index], index)
    },

    // 有效房型
    roomFilter() {
      const arr = this.searchList
        .map((item) => {
          if (!item.isDisabled) {
            return item
          }
          return null
        })
        .filter((x) => x !== null)

      return arr
    },
    // 拼接费用列表
    // 比如有2个有效的房型 费用列表有2个费用则那个费用表格显示4个费用数据
    getFeeList() {
      let list = []
      if (this.roomPriceData) {
        let fees = this.roomPriceData.fees
        // fees = fees
        //   .map((item) => {
        //     if (item.feeUnit == 'PER_STAY') {
        //       return item
        //     }
        //     return null
        //   })
        //   .filter((x) => x !== null)

        if (fees.length > 0) {
          // 有效房型
          let roomArr = this.roomFilter()
          if (roomArr.length > 0) {
            fees.forEach((item) => {
              let obj = {
                feeName: item.name_translate,
                feeUnit: item.feeUnit_translate,
                feeValue: item.feeValue,
                feeValueType: item.feeValueType,
                feeType: item.feeType,
              }
              roomArr.forEach((room) => {
                list.push({ ...room, ...obj })
              })
            })
          }
        } else {
          this.step = 3
          return false
        }
      }
      console.log(list)
      this.otherFee = list
      this.step = 2
    },
    // 下一步
    next() {
      if (this.step == 1) {
        this.getFeeList()
      } else if (this.step == 2) {
        this.step = 3
      } else if (this.step == 3) {
        this.$refs.productSelect.next()
        this.step = 4
      } else if (this.step == 4) {
        this.step = 5
      }
    },
    stepBack() {
      if (this.step == 1) {
        // 重置搜索
        this.searchList = null
        this.step = null
        this.date = ''
        this.resetForm('form')
      } else {
        this.step = this.step - 1
      }
    },
    // 创建订单
    createOrder() {
      const loading = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      const userInfo = this.$ls.get(USER_INFO)
      let data = {
        apiOrderModels: [],
        checkInDate: this.form.checkInDate,
        checkOutDate: this.form.checkOutDate,
        hotelId: this.$route.params.id,
        // productOrderVoList: [],
        userId: userInfo.id,
      }

      let roomList = this.roomFilter()
      if (roomList.length > 0) {
        roomList.forEach((item) => {
          data.apiOrderModels.push({
            channelName: 'One Step',
            fromDate: this.form.checkInDate,
            persons: item.guestNum,
            productId: item.productId,
            toDate: this.form.checkOutDate,
            userId: userInfo.id,
          })
        })
      }

      if (this.productOrderVoList.length > 0) {
        data.productOrderVoList = this.productOrderVoList
        data.productOrderVoList.forEach(product => {
          product.userId = userInfo.id;
        });
      }
      postAction(`/user/api/createOrder`, data)
        .then((res) => {
          loading.close()
          if (res.success) {
            this.payMethodVisible = true
            this.groupId = res.result
          }
        })
        .catch(() => {
          loading.close()
        })
    },
    
    // 创建订单支付
    createPayment(platForm) {
      this.$store.dispatch('createPayment', {
        groupId: this.groupId, // 组合订单Id
        hotelId: this.$route.params.id,
        platForm, // Stripe , Paypay
      })
    },

    // 房型编号
    getListNumber(arr, item, index) {
      let number = 1
      if (arr.length > 0) {
        const i = arr.findIndex((x) => x.roomTypeId == item.roomTypeId)
        number = `${index - i + 1}`
      }
      return number
    },

    // 删除房型
    roomDelete(index) {
      // 最后一个有效房型不能删除
      // const arr = this.searchList.filter((x) => x.isDisabled == false)
      // if(arr.length == 1) {}
      this.searchList.splice(index, 1)
    },

    storeProductInfo(price, productChooseList) {
      this.productTotalPrice = price
      this.productOrderVoList = productChooseList
    },
  },
}
</script>

<style>
 /*.el-form-item{*/
 /*  margin-top: 20px;*/
 /*}*/
</style>